<div class="flex-row padding-top">
  <div class="flex-1"></div>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-content flex-1">
    <h2 class="center-text">Login</h2>

    <mat-form-field appearance="outline">
      <mat-label>Email Address</mat-label>
      <input type="text" matInput formControlName="emailAddress">
      @if (formControls.emailAddress.hasError('required')) {
        <mat-error>Email is required.</mat-error>
      }
      @if (formControls.emailAddress.hasError('email')) {
        <mat-error>Email is invalid.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input type="password" matInput formControlName="password">
      @if (formControls.password.hasError('required')) {
        <mat-error>Password is required.</mat-error>
      }
    </mat-form-field>

    @if (isLoginFailed) {
      <div class="red-text error-padding">
        {{errorMessage}}
      </div>
    }

    <div class="form-group">
      @if (!loading) {
        <button mat-raised-button color="primary" type="submit" class="btn btn-primary span-form" [disabled]="loading || !loginForm.valid">
          Login
        </button>
      }

      @if (loading) {
        <mat-progress-bar style="height: 8px;" mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </form>
  <div class="flex-1"></div>
</div>
